import { TaskStatus } from '@dadohr/shared/domainTypes/experience';
import assertNever from 'assert-never';
import { useMemo } from 'react';
import { Color, ColoredChip } from '../../../../components/ColoredChip';
import { UnsafeTFunction, useUnsafeTranslation } from '../../../../i18next';

export const getTaskStatusChipConfig = (
  status: TaskStatus,
  t: UnsafeTFunction
): [string, Color] => {
  switch (status) {
    case TaskStatus.NOT_STARTED:
      return [t('Upcoming'), 'gray'];
    case TaskStatus.RUNNING:
      return [t('To Do'), 'blue'];
    case TaskStatus.LATE:
      return [t('Overdue'), 'red'];
    case TaskStatus.COMPLETE:
      return [t('Done'), 'green'];
    case TaskStatus.SKIPPED:
      return [t('Skipped'), 'darkGray'];
    case TaskStatus.PAST_DEADLINE:
      return [t('Past Deadline'), 'darkGray'];
    default:
      return assertNever(status);
  }
};

export const TaskStatusChip = ({
  status,
  variant,
  autoWidth,
  color = 'normal'
}: {
  status: TaskStatus;
  variant?: 'rounded' | 'squared';
  autoWidth?: boolean;
  color?: 'light' | 'normal';
}) => {
  const { t } = useUnsafeTranslation();
  const [label, c] = useMemo(() => getTaskStatusChipConfig(status, t), [
    status,
    t
  ]);
  return (
    <ColoredChip
      color={c}
      size="small"
      width={autoWidth ? 'auto' : 104}
      variant={variant}
      mode={color}
    >
      {label}
    </ColoredChip>
  );
};
